<ng-container *transloco="let t; read: 'password_change'">
  <div class="p-d-flex p-flex-column p-jc-center p-ai-center" style="height: 90vh;">
    <p-card header="{{ t('title') }}" class="login-card">

      <p>{{ t('intro_text') }}</p>

      <app-lang-selector></app-lang-selector>
      <p-messages [(value)]="messages"></p-messages>

      <form (ngSubmit)="onSubmit()" novalidate>
        <app-form-control [cid]="'old'" [control]="form.get('old')" [type]="'password'" [label]="t('labels.old')"></app-form-control>
        <app-form-control [cid]="'new'" [control]="form.get('new')" [type]="'password'" [label]="t('labels.new')"></app-form-control>
        <app-form-control [cid]="'confirm'" [control]="form.get('confirm')" [type]="'password'" [label]="t('labels.confirm')"></app-form-control>
        <div class="p-text-right">
          <button pButton type="button" label="{{ t('labels.cancel') }}" (click)="onCancel()" class="p-button-outlined p-mr-2"></button>
          <button pButton type="submit" label="{{ t('labels.change_password') }}" [disabled]="busy === true"></button>
        </div>
      </form>

    </p-card>
  </div>
</ng-container>
